import axios from "axios"
import router from "@/router";
import { ElMessage } from 'element-plus'
import { envConfig } from '@/config/env'
import { clearAuthCache } from '@/utils/authCache'

const service = axios.create({
    baseURL: envConfig.apiBaseUrl,
    timeout: envConfig.timeout,
    headers: {
        "Content-Type": "application/json; charset = utf-8"
    }
})

// 请求拦截
service.interceptors.request.use(
    config => {
        let token = sessionStorage.getItem("wuyetoken");
        if (!token) {
            token = localStorage.getItem("wuyetoken");
        }
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截
service.interceptors.response.use(
    response => {
        const data = response.data;
        
        // 兼容部分接口返回 status=200 且 msg=成功，但 success=false 的情况
        const isSuccessMessage = data
            && typeof data === 'object'
            && data.status === 200
            && typeof data.msg === 'string'
            && data.msg.includes('成功');

        if (isSuccessMessage) {
            return data;
        }

        // 处理业务错误：success 为 false 时提示 msg
        if (data && typeof data === 'object' && data.success === false) {
            const errorMsg = data.msg || '操作失败';
            if (!(response.config as any)?.suppressBusinessErrorMessage) {
                ElMessage.error(errorMsg);
            }
            return Promise.reject(new Error(errorMsg));
        }
        
        return data;
    },
    error => {
        console.error('请求错误:', error)
        
        // 检查响应数据中的status字段或HTTP状态码
        const status = error.response?.status || error.status;
        
        if (status && status >= 500 && status < 600) {
            ElMessage.error('网络错误，请稍后重试');
            return Promise.reject(new Error('网络错误'));
        }

        if (status == 401) {
            console.log('检测到401状态码，跳转到登录页');
            clearAuthCache();
            // 显示提示信息
            ElMessage.error('登录已过期，请重新登录');
            // 跳转到登录页
            router.push({ name: 'login' });
            return Promise.reject(new Error('登录已过期'));
        }
        
        return Promise.reject(error);
    }
)

export default service;
